export default __webpack_public_path__ + "static/media/premium.985d321e.svg";